import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class RoutingStateService {
    private history = [];

    constructor(private router: Router) {}

    public loadRouting(): void {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(({ urlAfterRedirects }: NavigationEnd) => {
                this.history = [...this.history, urlAfterRedirects];
            });
    }

    public getHistory(): string[] {
        return this.history;
    }

    public getPreviousUrl(): string {
        const lastUrl = this.history[this.history.length - 2];
        return lastUrl ? decodeURIComponent(lastUrl) : '/homepage';
    }
}
